import { twoDecimal } from '../../../../../utils/formatNumber';

export class InvoiceGLBuilder {
  constructor({ invoiceItemData, subcategories, invoiceGLItems }) {
    this.invoiceItemData = invoiceItemData;
    this.invoiceGLItems = invoiceGLItems;
    this.subcategories = subcategories;
  }

  glItemsWithAdditional(items, savedGls) {
    const count = items?.length || 0;
    const shippingAmount = this.invoiceItemData?.invoice?.shipping || 0;
    const shippingAmountInCents = Math.round(shippingAmount * 100);
    const baseShippingAmountInCents = count ? Math.trunc(shippingAmountInCents / count) : 0;
    let remainder = shippingAmountInCents - baseShippingAmountInCents * count; 
    const step = Math.sign(remainder);

    return items?.map((item, index) => {
      let shippingForThisItemInCents = baseShippingAmountInCents;
      if (remainder !== 0) {
        shippingForThisItemInCents += step;
        remainder -= step;
      }
      return {
        ...Object.keys(item).reduce((acc, key) => {
          acc[key] = item[key] === null ? '' : item[key];
          return acc;
        }, {}),
        id: index,
        shipping: savedGls ? twoDecimal(item.shipping) : shippingForThisItemInCents / 100,
        amount: twoDecimal(item.amount),
      };
    });
  }

  unconsolidatedGls() {
    const groupedItems = this.invoiceItemData?.invoiceItems
      ?.map((item, index) => {
        const subcategory = this.subcategories
          ?.filter((x) => x.facilityId === this.invoiceItemData?.invoice?.facilityId)
          ?.find((x) => x.subcategoryId === item?.subcategoryId);

        const { glCode } = subcategory || {};
        return {
          id: index,
          invoiceId: this.invoiceItemData?.invoice?.id,
          facilityId: this.invoiceItemData?.invoice?.facilityId,
          agoraCategoryId: item?.categoryId,
          agoraSubcategoryId: item?.subcategoryId,
          agoraCategory: item?.category,
          agoraSubcategory: item?.subcategory,
          glCode,
          shipping: 0,
          amount: item?.price * item?.quantity + item?.taxAmount,
          glItemId: 0,
          memo: item?.description !== null ? `${item?.description}. Qty: ${item.quantity}` : `Qty: ${item.quantity}`, //for unconsolidated, include qty in memo
          referenceNumber: '',
        };
      })
      .filter((x) => x.glCode);
    return groupedItems !== undefined ? Object.values(groupedItems) : groupedItems;
  }

  groupByGls() {
    const groupedItems = this.invoiceItemData?.invoiceItems?.reduce((group, item, index) => {
      const subcategory = this.subcategories
        ?.filter((x) => x.facilityId === this.invoiceItemData?.invoice?.facilityId)
        ?.find((x) => x.subcategoryId === item?.subcategoryId);
      const { glCode } = subcategory || {};
      if (glCode !== null && glCode !== undefined) {
        const newAmount = item?.price * item?.quantity + item?.taxAmount;
        group[glCode] = group[glCode] ?? {
          id: index,
          invoiceId: this.invoiceItemData?.invoice?.id,
          facilityId: this.invoiceItemData?.invoice?.facilityId,
          agoraCategoryId: item?.categoryId,
          agoraSubcategoryId: item?.subcategoryId,
          agoraCategory: item?.category,
          agoraSubcategory: item?.subcategory,
          glCode,
          shipping: 0,
          amount: 0,
          glItemId: 0,
          memo: '',
          referenceNumber: '',
        };
        group[glCode].amount += newAmount;
      }
      return group;
    }, {});
    return groupedItems !== undefined ? Object.values(groupedItems) : groupedItems;
  }

  getGlItems() {
    if (this.invoiceGLItems?.length === 0) {
      const items = this.invoiceItemData?.invoice?.unconsolidatedGls ? this.unconsolidatedGls() : this.groupByGls();
      return this.glItemsWithAdditional(items, false);
    }
    return this.glItemsWithAdditional(this.invoiceGLItems, true);
  }
}
